module.exports = __webpack_public_path__ + "static/img/wx_qrcode.b9f530fb.jpg";